
<div class="dashboard-dialog-title-block" mat-dialog-title>
	<span class="dashboard-dialog-title-label label-orange-color" translate>dashboard.add-widget</span>
</div>


<div class="add-widget-container" mat-dialog-content>
	<div class="select-widget-block">
		<span translate>dashboard.add-widget-instruction</span>
		<ul class="widget-list">
			<li *ngFor="let widget of allAvailableWidgets | keyvalue">
				<a href="#" [class.label-orange-color]="widget.key === selectedWidget"
					(click)="$event.preventDefault();onSelectWidget(widget.key)">
					{{ widget.key.translationKey | translate }}
				</a>
			</li>
		</ul>

	</div>
	<div class="select-content-block" *ngIf="selectedWidget">
		<ng-container [ngSwitch]="selectedWidget.name">
			<copo-biggest-stocks-selector *ngSwitchCase="BIGGEST_STOCKS_WIDGET" [currentContent]="oldContent" (content)="currentContent = $event"></copo-biggest-stocks-selector>
			<copo-issue-follow-up-selector *ngSwitchCase="ISSUE_FOLLOW_UP_WIDGET" [currentContent]="oldContent" (content)="currentContent = $event"></copo-issue-follow-up-selector>
			<copo-rts-content-selector *ngSwitchCase="RTS_WIDGET" [currentContent]="oldContent" (content)="currentContent = $event"></copo-rts-content-selector>
		</ng-container>
	</div>
</div>

<div class="save-cancel-button-block-confirmation" mat-dialog-actions>
	<div class="save-cancel-button-container">
		<button type="button" mat-raised-button class="customize-button" (click)="onCancelClick()">
			<span translate>dashboard.cancel</span>
		</button>
		<button type="submit" mat-raised-button color="primary" (click)="onValidateClick(currentContent!)" [disabled]="!currentContent" class="customize-button-dark">
			<span translate>dashboard.validate</span>
		</button>
	</div>
</div>
